import React from 'react'
import { Divider, ListItem } from '@fs/zion-ui'
import { cssClickableLink } from '../../LcrDemo/common/styles'

/**
 * @describe - Renders temple submenu items with consistent styling and behavior
 */
export default function TempleSubMenuItems({
  templeSubMenuItems = [],
  handleMenuItemClick,
  inlineMargin = false,
  showDividers = false,
}) {
  return (
    <div>
      {templeSubMenuItems.map(({ dataTestId, isDivider, isHeading, primaryText, to }) => {
        if (isDivider) return <Divider key="divider" />

        return (
          <div
            style={inlineMargin ? { marginInlineStart: '16px' } : undefined}
            css={to ? cssClickableLink : undefined}
            key={primaryText}
          >
            <ListItem
              key={primaryText}
              data-testid={dataTestId}
              emphasized={isHeading}
              disabled={!to}
              to={to ? `${to}/?tryDemo=true` : undefined}
              onClick={handleMenuItemClick}
              primaryText={primaryText}
            />
            {showDividers && !isDivider && <Divider />}
          </div>
        )
      })}
    </div>
  )
}
